(function () {
  var Real = window.Swiper;
  var queue = window.__swiperQueue;
  if (!queue || !queue.length || Real === window.__SwiperStub) return;
  window.__swiperQueue = [];
  queue.forEach(function (item) {
    item.proxy.__bind(Reflect.construct(Real, [].slice.call(item.args)));
  });
})();
